import { createFileRoute } from '@tanstack/react-router';

import { buildSeoHead, buildSoftwareApplicationSchema, jsonLdScript, ROUTE_META } from '@src/corelib/seo';
import { DefaultLayout } from '@src/layout';
import HomePage from '@src/pages/Home';

export const Route = createFileRoute('/')({
  head: () => ({
    ...buildSeoHead({ path: '/', ...ROUTE_META['/'] }),
    scripts: [jsonLdScript(buildSoftwareApplicationSchema())],
  }),
  component: HomePageWithLayout,
});

function HomePageWithLayout() {
  return (
    <DefaultLayout>
      <HomePage />
    </DefaultLayout>
  );
}
